<template>
  <div id="layBottom">
    <div class="statement">
      <div class="foot_box">
        <p style="align-items:flex-end">{{ 'copyright@ ' + yesr |U2M }}<span style="margin:0  3px ; color: var(--themeColor);" @click="getAqt">内蒙古阿启泰科技有限公司</span>版权所有
        </p>
        <p style="align-items:flex-start">经营许可证编号:蒙ICP备160044441号-2 联系方式：1072913745@qq.com </p>
      </div>

      <div class="mobile_phone">
        <div style="margin-right: 50px" @click="goMongolian" class="aqt_lang_mn titlefont">{{$t('m._mn')|U2M}}</div>
        <Poptip placement="top" popper-class="Poptip_phone_zh" trigger="hover">
          <div>移动端</div>
          <template #content>
            <img src="@/assets/images/eriweima.png">
          </template>
        </Poptip>
      </div>

    </div>


  </div>
</template>
<script>
export default {
  data() {
    return {
      yesr: '',
    }
  },
  methods: {
    getAqt() {
      window.open('http://web.aqitai.com', '_blank');
      this.$store.dispatch('saveUserBehavior', {
        type: 0,
        path: this.$route.path,
        mark: '点击跳转官网按钮'
      }).then(() => {
      })
    },

    goMongolian(){
      let that = this
      localStorage.removeItem("lang");
      localStorage.setItem("lang", 'mn');
      that.$store.dispatch('getLangStore', 'mn').then(() => {
      })
      if (sessionStorage.getItem('gcm') == 'school') {
        that.$router.replace({path: '/External', query: {lib_type: sessionStorage.getItem('gcm')}})
      } else {
        that.$router.replace({path: '/aqt', query: {lib_type: sessionStorage.getItem('gcm')}})
      }
    }
  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ? JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : "";
      return vv
    },
    // 用户id
    member_id() {
      let mm = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return mm
    },
  },
  created() {
    var date = new Date();
    this.yesr = date.getFullYear(); //获取当前年份(2位)
  }

}
</script>
<style lang="less" scoped>
#layBottom {
  height: 92px;
  width: 100%;
  position: relative;

  .statement {
    min-height: 77px;
    width: 100%;
    background: #ffffff;
    position: absolute;
    bottom: 0;
    left: 0;

    .foot_box {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      p {
        height: 38px;
        width: 50%;
        font-size: 14px;
        color: #888888;
        line-height: 20px;
        display: flex;
        //align-items: center;
        justify-content: center;

        span {
          cursor: pointer;
        }
      }
    }

    .mobile_phone {
      height: 100%;
      width: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--themeColor);
      font-size: 14px;
      cursor: pointer;
      position: absolute;
      right: 0;
      bottom: 0;
    }

    .tsSystem {
      height: 100%;
      width: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--themeColor);
      font-size: 12px;
      cursor: pointer;
      position: absolute;
      left: 0;
    }
  }


}
</style>

<style lang="less">
.Poptip_phone_zh {
  img {
    width: 150px;
    height: auto;
  }

  .ivu-poptip-body {
    padding: 16px !important;
  }
}
</style>
